module.exports = "<div style=\"position: relative;\" >\n    <ContentLoader :primaryColor=\"dtPalette['grey-3']\" >\n        <rect x=\"40\" y=\"5\" rx=\"1\" ry=\"1\" width=\"75%\" height=\"25\" />\n        <circle cx=\"30\" cy=\"17\" r=\"6\" />\n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/loaders/ticket-chat-editor-loader/template.html
// module id = 9BhV
// module chunks = 0